export class StaticThresholdAlarmParameters {

    constructor(
        public threshold: number = null,
        public period: number = null,
        public type: string = '',
        public hysteresis: number = null,
        public channel: number = null
    ) {
    }

}

